import { getEventBusIfDefined } from '@cian/event-bus';
import { changeFavorite } from '../api/favorite';
import { trackFlatFavoriteButtonClick } from '../utils/tracking';
export function toggleFavoriteAction(offerId) {
  return function (dispatch, getState, _ref) {
    var httpApi = _ref.httpApi,
      logger = _ref.logger,
      subdomain = _ref.subdomain;
    var _getState = getState(),
      MVKData = _getState.MVKData;
    var currentOffer = MVKData.offers.find(function (offer) {
      return offer.id === offerId;
    });
    if (!currentOffer) {
      return;
    }

    // обновление счетчика в хедере
    var updateHeaderFavoritesCount = function updateHeaderFavoritesCount(state) {
      if (window.__header_updateFavorites__) {
        // для микросервисов
        window.__header_updateFavorites__(state);
      } else if (window.__updateHeaderFavoritesCount) {
        // для монолита
        window.__updateHeaderFavoritesCount(state);
      }
    };
    var setFavorite = function setFavorite(isFavorite) {
      dispatch(setFavoriteAction(currentOffer.id, isFavorite));
      updateHeaderFavoritesCount(isFavorite);
    };
    setFavorite(!currentOffer.isFavorite);
    var customUrl = currentOffer.analyticsData ? currentOffer.analyticsData.customUrl : '';
    trackFlatFavoriteButtonClick(!currentOffer.isFavorite, customUrl);
    var parsedOfferUrl = currentOffer.url.split('/');
    if (parsedOfferUrl.length < 4) {
      return;
    }
    var changeFavoriteParams = {
      action: !currentOffer.isFavorite ? 'assign' : 'remove',
      dealType: parsedOfferUrl[1],
      offerType: parsedOfferUrl[2],
      oid: String(currentOffer.id)
    };
    changeFavorite(httpApi, changeFavoriteParams, logger, subdomain).then(function (res) {
      // если был добавлен ЖК, обновляем счетчик в хедере и посылаем событие о добавлении ЖК
      if (res.newbuilding_id) {
        updateHeaderFavoritesCount(true);
        var eventBus = getEventBusIfDefined();
        if (eventBus) {
          eventBus.emit('newbuilding_added_to_favorite', {
            type: String(res.newbuilding_id)
          });
        }
      }
    }).catch(function () {
      setFavorite(currentOffer.isFavorite);
    });
  };
}
export function setFavoriteAction(offerId, isFavorite) {
  return {
    isFavorite: isFavorite,
    offerId: offerId,
    type: 'ISetFavoriteAction'
  };
}